import { StatisticalAnalysisSidebarBase, StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { uniqueId } from 'lodash'
import { StatisticalAnalysisHeaderNavigationItems, StatisticalAnalysisHeaderValues, StatisticalAnalysisTypeNavigation } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { Nullable } from '@/shared/types/app.types'
import { LaboratoryStatisticalAnalysisSidebarDateInput } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-date-and-centers/statistical-analysis-sidebar-date-and-centers.model'
import { StatisticalAnalysisSearchBySidebarComboItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-search-by/statistical-analysis-sidebar-search-by.model'
import { StatisticalAnalysisDossiers, StatisticalAnalysisEnumsAndKeys, StatisticalAnalysisViewDetailParams } from '@/modules/statistical-analysis-module/shared/models/shared.model'

export interface StatisticalAnalysisSampleTagsDossierModelSearchInfo {
    typeSearch: Nullable<StatisticalAnalysisSidebarItemCombo>
    states: Nullable<StatisticalAnalysisSearchBySidebarComboItemCombo[]>
    laboratories: Nullable<LaboratoryStatisticalAnalysisSidebarDateInput[]>
    startDate: Nullable<Date>
    endDate: Nullable<Date>
    groupByCase: Nullable<boolean>
    grossedProcessedSamples: Nullable<boolean>
}

export interface StatisticalAnalysisSampleTagsDossierExternalInfo extends StatisticalAnalysisSampleTagsDossierModelSearchInfo{
    trackingGeneralSelected: Nullable<StatisticalAnalysisHeaderNavigationItems<number>>
}
const StatisticalAnalysisSampleTagsStatisticsDossierAxisXList = [
    StatisticalAnalysisEnumsAndKeys.SAMPLE_TYPE.getModel(),
    StatisticalAnalysisEnumsAndKeys.PATHOLOGIST.getModel(),
    StatisticalAnalysisEnumsAndKeys.RESPONSIBLE_REGROSSING.getModel(),
    StatisticalAnalysisEnumsAndKeys.PROCEDURE.getModel(),
    StatisticalAnalysisEnumsAndKeys.MOST_LIKELY_MORPHOLOGIC_CODE.getModel(),
    StatisticalAnalysisEnumsAndKeys.PHYSICIAN_HEALTH_MANAGEMENT_AREA.getModel(),
    StatisticalAnalysisEnumsAndKeys.PHYSICIAN_CENTER.getModel(),
    StatisticalAnalysisEnumsAndKeys.PHYSICIAN_UNIT.getModel()
]

export interface StatisticalAnalysisLabeledSampleTagsDossierState extends StatisticalAnalysisSidebarBase {
    headerData: StatisticalAnalysisHeaderValues
    viewDetail: StatisticalAnalysisViewDetailParams
    externalInfo: StatisticalAnalysisSampleTagsDossierExternalInfo
    promiseNavigationItems: Nullable<Promise<void>>
}
export const initialStatisticalAnalysisLabeledSampleTagsDossierState =
    (): StatisticalAnalysisLabeledSampleTagsDossierState => ({
        sidebar: {
            title: 'statisticalAnalysis.sections.labeledSamples',
            id: 'labeled-samples',
            components: [
                {
                    name: 'StatisticalAnalysisSidebarDateAndCenters',
                    id: uniqueId(),
                    props: { }
                },
                {
                    name: 'StatisticalAnalysisSidebarSearchBy',
                    id: uniqueId(),
                    props: {
                        showTypeSearch: false,
                        filterByStates: true,
                        options: [
                            StatisticalAnalysisEnumsAndKeys.CASE.getModel()
                        ],
                        preselection: StatisticalAnalysisEnumsAndKeys.CASE.getModel()
                    }
                },
                {
                    name: 'StatisticalAnalysisSidebarCheckbox',
                    id: uniqueId(),
                    props: {
                        label: 'statisticalAnalysis.sidebar.groupByCase',
                        nameCheckbox: 'groupByCase'
                    }
                },
                {
                    name: 'StatisticalAnalysisSidebarCheckbox',
                    id: uniqueId(),
                    props: {
                        label: 'statisticalAnalysis.sidebar.grossedProcessedSamples',
                        nameCheckbox: 'grossedProcessedSamples'
                    }
                }
            ]
        },
        headerData: {
            header: {
                total: 83630,
                showTotal: true,
                startDate: new Date(),
                endDate: new Date(),
                elementType: ''
            },
            navigationItems: [],
            navigationType: StatisticalAnalysisTypeNavigation.NAVIGATION,
            styles: {
                background: require('@/img/labeled-samples-bg.jpg'),
                icon: 'far fa-prescription-bottle'
            }
        },
        externalInfo: {
            typeSearch: null,
            states: null,
            laboratories: null,
            startDate: null,
            endDate: null,
            groupByCase: null,
            grossedProcessedSamples: null,
            trackingGeneralSelected: null
        },
        viewDetail: {
            dossier: StatisticalAnalysisDossiers.SAMPLE_TAGS,
            table: {
                contextMenuItems: {
                    detailChart: false,
                    detailList: true
                },
                temporalFilter: {
                    isShow: false
                }
            },
            chart: {
                axis: {
                    xAxis: {
                        show: true,
                        mainCombo: {
                            list: StatisticalAnalysisSampleTagsStatisticsDossierAxisXList,
                            selected: StatisticalAnalysisSampleTagsStatisticsDossierAxisXList[0]
                        },
                        associatedCombo: {
                            list: StatisticalAnalysisSampleTagsStatisticsDossierAxisXList,
                            selected: StatisticalAnalysisSampleTagsStatisticsDossierAxisXList[1]
                        }
                    },
                    yAxis: {
                        show: false
                    }
                },
                showExtendedFilters: false
            }
        },
        promiseNavigationItems: null
    })
